import "./App.css";
import React, { useState, useEffect, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./components/Header/Header";
import Header2 from "./components/Header/Header2";
import Footer from "./components/Footer/Footer";
import Loading from "./components/Loading/Loading";
import { AccessibilityProvider } from "./Accessibility/AccessibilityContext";
import { useAccessibility } from "./Accessibility/AccessibilityContext";
import "./Accessibility/accessibility.css";
import AccessibilityControls from "./Accessibility/AccessibilityControls";
import AccessibilityTopBar from "./Accessibility/AccessibilityTopBar";
// Lazy load route-level components
const HomePage = lazy(() => import("./components/HomePage/HomePage"));
const DynamicPage = lazy(() => import("./components/DynamicPages/DynamicPage"));
const GetInTouch = lazy(() => import("./components/GetInTouch/GetInTouch"));
const PrivacyPolicy = lazy(() => import("./components/Footer/PrivacyPolicy"));

function App() {
  return (
    <AccessibilityProvider>
      <Router>
        <AppContent />
      </Router>
    </AccessibilityProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { fontScale, contrast, brightness } = useAccessibility();

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--font-scale",
      Math.min(fontScale, 4),
    );

    document.getElementById("app-root").style.filter = `
      brightness(${brightness}) contrast(${contrast / 100})
    `;
  }, [fontScale, contrast, brightness]);

  useEffect(() => {
    // Trigger loading state on route change
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {/* 👇 brightness applied ONLY to scrolling content */}
      <AccessibilityTopBar />
      <div id="app-root" style={{ filter: `brightness(${brightness})` }}>
        {" "}
        {isLoading && <Loading />}
        {!isLoading && (
          <>
            <Header />
            <Header2 />

            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route
                  path="/personal-banking/deposit-schemes/:title/:id"
                  element={<DynamicPage />}
                />
                <Route
                  path="/personal-banking/advances/:title/:id"
                  element={<DynamicPage />}
                />
                <Route path="/:service/:title/:id" element={<DynamicPage />} />
                <Route path="/getintouch" element={<GetInTouch />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              </Routes>
            </Suspense>

            <Footer />
          </>
        )}
      </div>

      {/* 👇 NOT inside filtered content */}
      <AccessibilityControls />
    </>
  );
}

export default App;
